<template>
  <v-btn 
    class="ml-3" 
    dense 
    @click="handleClick"
    :class="{'active-class': active}"
  >
  <v-icon v-if="icon" class="mr-2">{{ icon }}</v-icon>
    <slot></slot>
  </v-btn>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const emit = defineEmits();
const props = defineProps({
  routeName: {
    type: String,
    required: true,
  },
  icon: {
    type: String, // Example: "mdi-home", "mdi-account"
    default: "",
  },
  active: {
    type: Boolean,
    default: false,
  },
});

const handleClick = () => {
  emit('navigate', props.routeName);
};
</script>

<style scoped>
.active-class {
  background-color: #633cbd; 
  color: white;
  /* border: 2px solid #4a1b8b;  */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); 
}

.v-btn {
  transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
}

.v-btn:hover {
  background-color: #703cbe42; 
}

.v-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(174, 146, 241, 0.4); 
}
</style>
